import { getAuth0UiLocales } from './get-auth0-ui-locales';

/**
 * Appends Auth0 `ui_locales` to a hosted Auth0 URL for the active build locale.
 * Used for password-change ticket redirects so the reset UI matches the app language.
 *
 * @param url Absolute Auth0 ticket or hosted page URL.
 * @returns The URL with `ui_locales` set (`fr-CA` or `en`).
 */
export function withAuth0UiLocales(url: string): string {
  const parsed = new URL(url);
  parsed.searchParams.set('ui_locales', getAuth0UiLocales());
  return parsed.href;
}
